/** Terminal phase state wins over stale progress prose saved during a run. */
export function playbookPhaseLabel(name: string, status: string | undefined, liveText: string | undefined, active: boolean): string {
  if (status === 'completed') return `Completed: ${name}`;
  if (status === 'failed') return `Failed: ${name}`;
  if (status === 'skipped') return `Skipped: ${name}`;
  return active && status === 'running' ? liveText || name : name;
}
